import Route from 'cio/routes/base';
import SqlImportModel from 'cio/models/sql-import';
import { inject as service } from '@ember/service';
import DS from 'ember-data';

export default class SqlImportsImportRoute extends Route {
  @service store!: DS.Store;

  crumb() {
    let model = this.modelFor(this.routeName) as SqlImportModel;

    return {
      get name() {
        return model.name ?? 'SQL Sync';
      },
      path: 'sql-imports.import',
      model,
    };
  }

  model(params: { sql_import_id: string }) {
    return this.store.findRecord('sql-import', params.sql_import_id);
  }
}
